/* eslint-disable */
// @ts-nocheck
"use client";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _UserCreateAborted_error, _UserCreateAborted_message, _UserSetClaimsAborted_error, _UserSetClaimsAborted_message, _UserSignUpAborted_error, _UserSignUpAborted_message, _UserSetSurveyDataAborted_error, _UserSetSurveyDataAborted_message, _UserSetStatusAborted_error, _UserSetStatusAborted_message, _UserActivateAborted_error, _UserActivateAborted_message, _UserGetAborted_error, _UserGetAborted_message, _UserAddToOrganizationAborted_error, _UserAddToOrganizationAborted_message, _UserRemoveFromOrganizationAborted_error, _UserRemoveFromOrganizationAborted_message, _UserSetLastSelectedOrganizationAborted_error, _UserSetLastSelectedOrganizationAborted_message, _UserCreateAPIKeyAborted_error, _UserCreateAPIKeyAborted_message, _UserDeleteAPIKeyAborted_error, _UserDeleteAPIKeyAborted_message, _UserGetAPIKeysForOrganizationAborted_error, _UserGetAPIKeysForOrganizationAborted_message, _UsersAddAborted_error, _UsersAddAborted_message, _UsersGetAborted_error, _UsersGetAborted_message;
import * as protobuf_es from "@bufbuild/protobuf";
import { Empty } from "@bufbuild/protobuf";
import * as reboot_react from "@reboot-dev/reboot-react";
import * as reboot_web from "@reboot-dev/reboot-web";
import * as reboot_api from "@reboot-dev/reboot-api";
import React, { useEffect, useMemo, useRef, useState, } from "react";
import { v4 as uuidv4 } from "uuid";
import { useDefaultStateIds, useRefreshBearerToken } from "@reboot-dev/reboot-react/internal";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './user_pb.js'
//
// You can resolve this by passing --react-extensions to `rbt
// generate` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import { User as UserProto, Users as UsersProto, } from "./user_pb.js";
import * as user_pb from "./user_pb.js";
// Additionally re-export all messages_and_enums from the pb module.
export { SurveyData, AddRequest, AddResponse, UsersGetRequest, UsersGetResponse, InvalidInputError, UserSetClaimsRequest, SignUpRequest, SignUpResponse, SetSurveyDataRequest, SetSurveyDataResponse, SetStatusRequest, SetStatusResponse, ActivateResponse, GetRequest, GetResponse, AddToOrganizationRequest, AddToOrganizationResponse, RemoveFromOrganizationRequest, RemoveFromOrganizationResponse, SetLastSelectedOrganizationRequest, SetLastSelectedOrganizationResponse, CreateAPIKeyRequest, CreateAPIKeyResponse, DeleteAPIKeyRequest, DeleteAPIKeyResponse, GetAPIKeysForOrganizationRequest, APIKeyView, GetAPIKeysForOrganizationResponse, } from "./user_pb.js";
// It is important that the following is a function, so we can lazily
// initialize the cache, so users who do not use offline cache do not
// see any logs about its initialization.
export const offlineCacheStorageType = () => reboot_web.offlineCache().offlineCacheStorageType;
reboot_api.check_bufbuild_protobuf_library(protobuf_es.Message);
const ERROR_TYPES = [
    // gRPC errors.
    reboot_api.errors_pb.Cancelled,
    reboot_api.errors_pb.Unknown,
    reboot_api.errors_pb.InvalidArgument,
    reboot_api.errors_pb.DeadlineExceeded,
    reboot_api.errors_pb.NotFound,
    reboot_api.errors_pb.AlreadyExists,
    reboot_api.errors_pb.PermissionDenied,
    reboot_api.errors_pb.ResourceExhausted,
    reboot_api.errors_pb.FailedPrecondition,
    reboot_api.errors_pb.Aborted,
    reboot_api.errors_pb.OutOfRange,
    reboot_api.errors_pb.Unimplemented,
    reboot_api.errors_pb.Internal,
    reboot_api.errors_pb.Unavailable,
    reboot_api.errors_pb.DataLoss,
    reboot_api.errors_pb.Unauthenticated,
    // Reboot errors.
    //
    // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
    reboot_api.errors_pb.StateAlreadyConstructed,
    reboot_api.errors_pb.StateNotConstructed,
    reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
    reboot_api.errors_pb.TransactionParticipantFailedToCommit,
    reboot_api.errors_pb.TransactionShouldRetry,
    reboot_api.errors_pb.UnknownService,
    reboot_api.errors_pb.UnknownTask,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserCreateRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof Empty
        ? partialRequest
        : Empty.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserCreateRequestFromJsonString = (jsonRequest) => {
    return UserCreateRequestFromProtobufShape(Empty.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserCreateRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof Empty
        ? partialRequest
        : new Empty(partialRequest);
};
const UserCreateResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof Empty
        ? partialResponse
        : Empty.fromJson(partialResponse);
    return response;
};
const UserCreateResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof Empty
        ? partialResponse
        : new Empty(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserSetClaimsRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.UserSetClaimsRequest
        ? partialRequest
        : user_pb.UserSetClaimsRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserSetClaimsRequestFromJsonString = (jsonRequest) => {
    return UserSetClaimsRequestFromProtobufShape(user_pb.UserSetClaimsRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserSetClaimsRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.UserSetClaimsRequest
        ? partialRequest
        : new user_pb.UserSetClaimsRequest(partialRequest);
};
const UserSetClaimsResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof Empty
        ? partialResponse
        : Empty.fromJson(partialResponse);
    return response;
};
const UserSetClaimsResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof Empty
        ? partialResponse
        : new Empty(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserSignUpRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.SignUpRequest
        ? partialRequest
        : user_pb.SignUpRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserSignUpRequestFromJsonString = (jsonRequest) => {
    return UserSignUpRequestFromProtobufShape(user_pb.SignUpRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserSignUpRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.SignUpRequest
        ? partialRequest
        : new user_pb.SignUpRequest(partialRequest);
};
const UserSignUpResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.SignUpResponse
        ? partialResponse
        : user_pb.SignUpResponse.fromJson(partialResponse);
    return response;
};
const UserSignUpResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.SignUpResponse
        ? partialResponse
        : new user_pb.SignUpResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserSetSurveyDataRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.SetSurveyDataRequest
        ? partialRequest
        : user_pb.SetSurveyDataRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserSetSurveyDataRequestFromJsonString = (jsonRequest) => {
    return UserSetSurveyDataRequestFromProtobufShape(user_pb.SetSurveyDataRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserSetSurveyDataRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.SetSurveyDataRequest
        ? partialRequest
        : new user_pb.SetSurveyDataRequest(partialRequest);
};
const UserSetSurveyDataResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.SetSurveyDataResponse
        ? partialResponse
        : user_pb.SetSurveyDataResponse.fromJson(partialResponse);
    return response;
};
const UserSetSurveyDataResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.SetSurveyDataResponse
        ? partialResponse
        : new user_pb.SetSurveyDataResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserSetStatusRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.SetStatusRequest
        ? partialRequest
        : user_pb.SetStatusRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserSetStatusRequestFromJsonString = (jsonRequest) => {
    return UserSetStatusRequestFromProtobufShape(user_pb.SetStatusRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserSetStatusRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.SetStatusRequest
        ? partialRequest
        : new user_pb.SetStatusRequest(partialRequest);
};
const UserSetStatusResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.SetStatusResponse
        ? partialResponse
        : user_pb.SetStatusResponse.fromJson(partialResponse);
    return response;
};
const UserSetStatusResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.SetStatusResponse
        ? partialResponse
        : new user_pb.SetStatusResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserActivateRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof Empty
        ? partialRequest
        : Empty.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserActivateRequestFromJsonString = (jsonRequest) => {
    return UserActivateRequestFromProtobufShape(Empty.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserActivateRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof Empty
        ? partialRequest
        : new Empty(partialRequest);
};
const UserActivateResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.ActivateResponse
        ? partialResponse
        : user_pb.ActivateResponse.fromJson(partialResponse);
    return response;
};
const UserActivateResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.ActivateResponse
        ? partialResponse
        : new user_pb.ActivateResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserGetRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.GetRequest
        ? partialRequest
        : user_pb.GetRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserGetRequestFromJsonString = (jsonRequest) => {
    return UserGetRequestFromProtobufShape(user_pb.GetRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserGetRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.GetRequest
        ? partialRequest
        : new user_pb.GetRequest(partialRequest);
};
const UserGetResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.GetResponse
        ? partialResponse
        : user_pb.GetResponse.fromJson(partialResponse);
    return response;
};
const UserGetResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.GetResponse
        ? partialResponse
        : new user_pb.GetResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserAddToOrganizationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.AddToOrganizationRequest
        ? partialRequest
        : user_pb.AddToOrganizationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserAddToOrganizationRequestFromJsonString = (jsonRequest) => {
    return UserAddToOrganizationRequestFromProtobufShape(user_pb.AddToOrganizationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserAddToOrganizationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.AddToOrganizationRequest
        ? partialRequest
        : new user_pb.AddToOrganizationRequest(partialRequest);
};
const UserAddToOrganizationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.AddToOrganizationResponse
        ? partialResponse
        : user_pb.AddToOrganizationResponse.fromJson(partialResponse);
    return response;
};
const UserAddToOrganizationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.AddToOrganizationResponse
        ? partialResponse
        : new user_pb.AddToOrganizationResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserRemoveFromOrganizationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.RemoveFromOrganizationRequest
        ? partialRequest
        : user_pb.RemoveFromOrganizationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserRemoveFromOrganizationRequestFromJsonString = (jsonRequest) => {
    return UserRemoveFromOrganizationRequestFromProtobufShape(user_pb.RemoveFromOrganizationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserRemoveFromOrganizationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.RemoveFromOrganizationRequest
        ? partialRequest
        : new user_pb.RemoveFromOrganizationRequest(partialRequest);
};
const UserRemoveFromOrganizationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.RemoveFromOrganizationResponse
        ? partialResponse
        : user_pb.RemoveFromOrganizationResponse.fromJson(partialResponse);
    return response;
};
const UserRemoveFromOrganizationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.RemoveFromOrganizationResponse
        ? partialResponse
        : new user_pb.RemoveFromOrganizationResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserSetLastSelectedOrganizationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.SetLastSelectedOrganizationRequest
        ? partialRequest
        : user_pb.SetLastSelectedOrganizationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserSetLastSelectedOrganizationRequestFromJsonString = (jsonRequest) => {
    return UserSetLastSelectedOrganizationRequestFromProtobufShape(user_pb.SetLastSelectedOrganizationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserSetLastSelectedOrganizationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.SetLastSelectedOrganizationRequest
        ? partialRequest
        : new user_pb.SetLastSelectedOrganizationRequest(partialRequest);
};
const UserSetLastSelectedOrganizationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.SetLastSelectedOrganizationResponse
        ? partialResponse
        : user_pb.SetLastSelectedOrganizationResponse.fromJson(partialResponse);
    return response;
};
const UserSetLastSelectedOrganizationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.SetLastSelectedOrganizationResponse
        ? partialResponse
        : new user_pb.SetLastSelectedOrganizationResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserCreateAPIKeyRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.CreateAPIKeyRequest
        ? partialRequest
        : user_pb.CreateAPIKeyRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserCreateAPIKeyRequestFromJsonString = (jsonRequest) => {
    return UserCreateAPIKeyRequestFromProtobufShape(user_pb.CreateAPIKeyRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserCreateAPIKeyRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.CreateAPIKeyRequest
        ? partialRequest
        : new user_pb.CreateAPIKeyRequest(partialRequest);
};
const UserCreateAPIKeyResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.CreateAPIKeyResponse
        ? partialResponse
        : user_pb.CreateAPIKeyResponse.fromJson(partialResponse);
    return response;
};
const UserCreateAPIKeyResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.CreateAPIKeyResponse
        ? partialResponse
        : new user_pb.CreateAPIKeyResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserDeleteAPIKeyRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.DeleteAPIKeyRequest
        ? partialRequest
        : user_pb.DeleteAPIKeyRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserDeleteAPIKeyRequestFromJsonString = (jsonRequest) => {
    return UserDeleteAPIKeyRequestFromProtobufShape(user_pb.DeleteAPIKeyRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserDeleteAPIKeyRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.DeleteAPIKeyRequest
        ? partialRequest
        : new user_pb.DeleteAPIKeyRequest(partialRequest);
};
const UserDeleteAPIKeyResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.DeleteAPIKeyResponse
        ? partialResponse
        : user_pb.DeleteAPIKeyResponse.fromJson(partialResponse);
    return response;
};
const UserDeleteAPIKeyResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.DeleteAPIKeyResponse
        ? partialResponse
        : new user_pb.DeleteAPIKeyResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UserGetAPIKeysForOrganizationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.GetAPIKeysForOrganizationRequest
        ? partialRequest
        : user_pb.GetAPIKeysForOrganizationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UserGetAPIKeysForOrganizationRequestFromJsonString = (jsonRequest) => {
    return UserGetAPIKeysForOrganizationRequestFromProtobufShape(user_pb.GetAPIKeysForOrganizationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UserGetAPIKeysForOrganizationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.GetAPIKeysForOrganizationRequest
        ? partialRequest
        : new user_pb.GetAPIKeysForOrganizationRequest(partialRequest);
};
const UserGetAPIKeysForOrganizationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.GetAPIKeysForOrganizationResponse
        ? partialResponse
        : user_pb.GetAPIKeysForOrganizationResponse.fromJson(partialResponse);
    return response;
};
const UserGetAPIKeysForOrganizationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.GetAPIKeysForOrganizationResponse
        ? partialResponse
        : new user_pb.GetAPIKeysForOrganizationResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UsersAddRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.AddRequest
        ? partialRequest
        : user_pb.AddRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UsersAddRequestFromJsonString = (jsonRequest) => {
    return UsersAddRequestFromProtobufShape(user_pb.AddRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UsersAddRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.AddRequest
        ? partialRequest
        : new user_pb.AddRequest(partialRequest);
};
const UsersAddResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.AddResponse
        ? partialResponse
        : user_pb.AddResponse.fromJson(partialResponse);
    return response;
};
const UsersAddResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.AddResponse
        ? partialResponse
        : new user_pb.AddResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const UsersGetRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof user_pb.UsersGetRequest
        ? partialRequest
        : user_pb.UsersGetRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const UsersGetRequestFromJsonString = (jsonRequest) => {
    return UsersGetRequestFromProtobufShape(user_pb.UsersGetRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const UsersGetRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof user_pb.UsersGetRequest
        ? partialRequest
        : new user_pb.UsersGetRequest(partialRequest);
};
const UsersGetResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof user_pb.UsersGetResponse
        ? partialResponse
        : user_pb.UsersGetResponse.fromJson(partialResponse);
    return response;
};
const UsersGetResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof user_pb.UsersGetResponse
        ? partialResponse
        : new user_pb.UsersGetResponse(partialResponse);
};
const USER_CREATE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserCreateAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_CREATE_ERROR_TYPES);
        if (error !== undefined) {
            return new UserCreateAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserCreateAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserCreateAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserCreateAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserCreateAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserCreateAborted_error.set(this, void 0);
        _UserCreateAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserCreateAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserCreateAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserCreateAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserCreateAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserCreateAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserCreateAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserCreateAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserCreateAborted_error, "f");
    }
}
_UserCreateAborted_error = new WeakMap(), _UserCreateAborted_message = new WeakMap();
const USER_SET_CLAIMS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserSetClaimsAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_SET_CLAIMS_ERROR_TYPES);
        if (error !== undefined) {
            return new UserSetClaimsAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserSetClaimsAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserSetClaimsAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserSetClaimsAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserSetClaimsAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserSetClaimsAborted_error.set(this, void 0);
        _UserSetClaimsAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserSetClaimsAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserSetClaimsAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserSetClaimsAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserSetClaimsAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserSetClaimsAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserSetClaimsAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserSetClaimsAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserSetClaimsAborted_error, "f");
    }
}
_UserSetClaimsAborted_error = new WeakMap(), _UserSetClaimsAborted_message = new WeakMap();
const USER_SIGN_UP_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserSignUpAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_SIGN_UP_ERROR_TYPES);
        if (error !== undefined) {
            return new UserSignUpAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserSignUpAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserSignUpAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserSignUpAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserSignUpAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserSignUpAborted_error.set(this, void 0);
        _UserSignUpAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserSignUpAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserSignUpAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserSignUpAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserSignUpAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserSignUpAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserSignUpAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserSignUpAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserSignUpAborted_error, "f");
    }
}
_UserSignUpAborted_error = new WeakMap(), _UserSignUpAborted_message = new WeakMap();
const USER_SET_SURVEY_DATA_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    user_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserSetSurveyDataAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_SET_SURVEY_DATA_ERROR_TYPES);
        if (error !== undefined) {
            return new UserSetSurveyDataAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserSetSurveyDataAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserSetSurveyDataAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserSetSurveyDataAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserSetSurveyDataAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserSetSurveyDataAborted_error.set(this, void 0);
        _UserSetSurveyDataAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserSetSurveyDataAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserSetSurveyDataAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserSetSurveyDataAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserSetSurveyDataAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserSetSurveyDataAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserSetSurveyDataAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserSetSurveyDataAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserSetSurveyDataAborted_error, "f");
    }
}
_UserSetSurveyDataAborted_error = new WeakMap(), _UserSetSurveyDataAborted_message = new WeakMap();
const USER_SET_STATUS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    user_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserSetStatusAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_SET_STATUS_ERROR_TYPES);
        if (error !== undefined) {
            return new UserSetStatusAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserSetStatusAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserSetStatusAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserSetStatusAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserSetStatusAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserSetStatusAborted_error.set(this, void 0);
        _UserSetStatusAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserSetStatusAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserSetStatusAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserSetStatusAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserSetStatusAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserSetStatusAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserSetStatusAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserSetStatusAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserSetStatusAborted_error, "f");
    }
}
_UserSetStatusAborted_error = new WeakMap(), _UserSetStatusAborted_message = new WeakMap();
const USER_ACTIVATE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserActivateAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_ACTIVATE_ERROR_TYPES);
        if (error !== undefined) {
            return new UserActivateAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserActivateAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserActivateAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserActivateAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserActivateAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserActivateAborted_error.set(this, void 0);
        _UserActivateAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserActivateAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserActivateAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserActivateAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserActivateAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserActivateAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserActivateAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserActivateAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserActivateAborted_error, "f");
    }
}
_UserActivateAborted_error = new WeakMap(), _UserActivateAborted_message = new WeakMap();
const USER_GET_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserGetAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_GET_ERROR_TYPES);
        if (error !== undefined) {
            return new UserGetAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserGetAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserGetAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserGetAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserGetAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserGetAborted_error.set(this, void 0);
        _UserGetAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserGetAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserGetAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserGetAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserGetAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserGetAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserGetAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserGetAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserGetAborted_error, "f");
    }
}
_UserGetAborted_error = new WeakMap(), _UserGetAborted_message = new WeakMap();
const USER_ADD_TO_ORGANIZATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserAddToOrganizationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_ADD_TO_ORGANIZATION_ERROR_TYPES);
        if (error !== undefined) {
            return new UserAddToOrganizationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserAddToOrganizationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserAddToOrganizationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserAddToOrganizationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserAddToOrganizationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserAddToOrganizationAborted_error.set(this, void 0);
        _UserAddToOrganizationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserAddToOrganizationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserAddToOrganizationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserAddToOrganizationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserAddToOrganizationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserAddToOrganizationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserAddToOrganizationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserAddToOrganizationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserAddToOrganizationAborted_error, "f");
    }
}
_UserAddToOrganizationAborted_error = new WeakMap(), _UserAddToOrganizationAborted_message = new WeakMap();
const USER_REMOVE_FROM_ORGANIZATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserRemoveFromOrganizationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_REMOVE_FROM_ORGANIZATION_ERROR_TYPES);
        if (error !== undefined) {
            return new UserRemoveFromOrganizationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserRemoveFromOrganizationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserRemoveFromOrganizationAborted_error.set(this, void 0);
        _UserRemoveFromOrganizationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserRemoveFromOrganizationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserRemoveFromOrganizationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserRemoveFromOrganizationAborted_error, "f");
    }
}
_UserRemoveFromOrganizationAborted_error = new WeakMap(), _UserRemoveFromOrganizationAborted_message = new WeakMap();
const USER_SET_LAST_SELECTED_ORGANIZATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserSetLastSelectedOrganizationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_SET_LAST_SELECTED_ORGANIZATION_ERROR_TYPES);
        if (error !== undefined) {
            return new UserSetLastSelectedOrganizationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserSetLastSelectedOrganizationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserSetLastSelectedOrganizationAborted_error.set(this, void 0);
        _UserSetLastSelectedOrganizationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserSetLastSelectedOrganizationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserSetLastSelectedOrganizationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserSetLastSelectedOrganizationAborted_error, "f");
    }
}
_UserSetLastSelectedOrganizationAborted_error = new WeakMap(), _UserSetLastSelectedOrganizationAborted_message = new WeakMap();
const USER_CREATE_API_KEY_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    user_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserCreateAPIKeyAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_CREATE_API_KEY_ERROR_TYPES);
        if (error !== undefined) {
            return new UserCreateAPIKeyAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserCreateAPIKeyAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserCreateAPIKeyAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserCreateAPIKeyAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserCreateAPIKeyAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserCreateAPIKeyAborted_error.set(this, void 0);
        _UserCreateAPIKeyAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserCreateAPIKeyAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserCreateAPIKeyAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserCreateAPIKeyAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserCreateAPIKeyAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserCreateAPIKeyAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserCreateAPIKeyAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserCreateAPIKeyAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserCreateAPIKeyAborted_error, "f");
    }
}
_UserCreateAPIKeyAborted_error = new WeakMap(), _UserCreateAPIKeyAborted_message = new WeakMap();
const USER_DELETE_API_KEY_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    user_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserDeleteAPIKeyAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_DELETE_API_KEY_ERROR_TYPES);
        if (error !== undefined) {
            return new UserDeleteAPIKeyAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserDeleteAPIKeyAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserDeleteAPIKeyAborted_error.set(this, void 0);
        _UserDeleteAPIKeyAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserDeleteAPIKeyAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserDeleteAPIKeyAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserDeleteAPIKeyAborted_error, "f");
    }
}
_UserDeleteAPIKeyAborted_error = new WeakMap(), _UserDeleteAPIKeyAborted_message = new WeakMap();
const USER_GET_API_KEYS_FOR_ORGANIZATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    user_pb.InvalidInputError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UserGetAPIKeysForOrganizationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USER_GET_API_KEYS_FOR_ORGANIZATION_ERROR_TYPES);
        if (error !== undefined) {
            return new UserGetAPIKeysForOrganizationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UserGetAPIKeysForOrganizationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UserGetAPIKeysForOrganizationAborted_error.set(this, void 0);
        _UserGetAPIKeysForOrganizationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UserGetAPIKeysForOrganizationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UserGetAPIKeysForOrganizationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UserGetAPIKeysForOrganizationAborted_error, "f");
    }
}
_UserGetAPIKeysForOrganizationAborted_error = new WeakMap(), _UserGetAPIKeysForOrganizationAborted_message = new WeakMap();
const USERS_ADD_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UsersAddAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USERS_ADD_ERROR_TYPES);
        if (error !== undefined) {
            return new UsersAddAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UsersAddAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UsersAddAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UsersAddAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UsersAddAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UsersAddAborted_error.set(this, void 0);
        _UsersAddAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UsersAddAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UsersAddAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UsersAddAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UsersAddAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UsersAddAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UsersAddAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UsersAddAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UsersAddAborted_error, "f");
    }
}
_UsersAddAborted_error = new WeakMap(), _UsersAddAborted_message = new WeakMap();
const USERS_GET_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class UsersGetAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, USERS_GET_ERROR_TYPES);
        if (error !== undefined) {
            return new UsersGetAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new UsersGetAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _UsersGetAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _UsersGetAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _UsersGetAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _UsersGetAborted_error.set(this, void 0);
        _UsersGetAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _UsersGetAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _UsersGetAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _UsersGetAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _UsersGetAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _UsersGetAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _UsersGetAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _UsersGetAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _UsersGetAborted_error, "f");
    }
}
_UsersGetAborted_error = new WeakMap(), _UsersGetAborted_message = new WeakMap();
class UserInstance {
    constructor(id, stateRef, url) {
        this.observers = {};
        this.loadingReaders = 0;
        this.runningMutates = [];
        this.queuedMutates = [];
        this.flushMutates = undefined;
        this.websocket = undefined;
        this.backoff = new reboot_api.Backoff();
        this.useCreateMutations = [];
        this.useCreateSetPendings = {};
        this.useSetClaimsMutations = [];
        this.useSetClaimsSetPendings = {};
        this.useSignUpMutations = [];
        this.useSignUpSetPendings = {};
        this.useSetSurveyDataMutations = [];
        this.useSetSurveyDataSetPendings = {};
        this.useSetStatusMutations = [];
        this.useSetStatusSetPendings = {};
        this.useGetReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.getFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useAddToOrganizationMutations = [];
        this.useAddToOrganizationSetPendings = {};
        this.useRemoveFromOrganizationMutations = [];
        this.useRemoveFromOrganizationSetPendings = {};
        this.useSetLastSelectedOrganizationMutations = [];
        this.useSetLastSelectedOrganizationSetPendings = {};
        this.useCreateAPIKeyMutations = [];
        this.useCreateAPIKeySetPendings = {};
        this.useDeleteAPIKeyMutations = [];
        this.useDeleteAPIKeySetPendings = {};
        this.useGetAPIKeysForOrganizationReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.getAPIKeysForOrganizationFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.id = id;
        this.stateRef = stateRef;
        this.url = url;
        this.refs = 1;
        // An empty `id` marks the inert instance shared by every no-id
        // caller while no default ID has resolved (e.g. signed out): it
        // opens no socket so there's nothing to connect to.
        if (id !== "") {
            reboot_web.websockets.connect(this.url, this.stateRef);
            this.initializeWebSocket();
        }
    }
    ref() {
        this.refs += 1;
        return this.refs;
    }
    unref() {
        this.refs -= 1;
        if (this.refs === 0 && this.websocket !== undefined) {
            this.websocket.close();
            reboot_web.websockets.disconnect(this.url, this.stateRef);
        }
        return this.refs;
    }
    hasRunningMutations() {
        return this.runningMutates.length > 0;
    }
    async flushMutations() {
        if (this.flushMutates === undefined) {
            this.flushMutates = new reboot_api.Event();
        }
        await this.flushMutates.wait();
    }
    readersLoadedOrFailed() {
        var _a;
        this.flushMutates = undefined;
        if (this.queuedMutates.length > 0) {
            this.runningMutates = this.queuedMutates;
            this.queuedMutates = [];
            if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                for (const { request, update } of this.runningMutates) {
                    update({ isLoading: true });
                    try {
                        this.websocket.send(request.toBinary());
                    }
                    catch (_b) {
                        // We'll retry since we've stored in `*Mutates`.
                    }
                }
            }
        }
    }
    initializeWebSocket() {
        if (this.websocket === undefined && this.refs > 0 && this.id !== "") {
            const url = new URL(`${this.url}/__/reboot/rpc/${this.stateRef}`);
            url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
            this.websocket = reboot_web.websockets.create(url);
            this.websocket.binaryType = "arraybuffer";
            this.websocket.onopen = () => {
                var _a;
                if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                    for (const { request, update } of this.runningMutates) {
                        update({ isLoading: true });
                        try {
                            this.websocket.send(request.toBinary());
                        }
                        catch (_b) {
                            // We'll retry since we've stored in `*Mutates`.
                        }
                    }
                }
            };
            this.websocket.onerror = async () => {
                if (this.websocket !== undefined) {
                    this.websocket = undefined;
                    for (const { update } of this.runningMutates) {
                        update({ isLoading: false, error: "WebSocket disconnected" });
                    }
                    if (this.refs > 0) {
                        if (this.runningMutates.length > 0) {
                            console.warn(`[Reboot] WebSocket disconnected, ${this.runningMutates.length} outstanding mutations will be retried when we reconnect`);
                        }
                        await this.backoff.wait();
                        this.initializeWebSocket();
                    }
                }
            };
            this.websocket.onclose = async () => {
                if (this.websocket !== undefined) {
                    this.websocket = undefined;
                    for (const { update } of this.runningMutates) {
                        update({ isLoading: false, error: "WebSocket disconnected" });
                    }
                    if (this.refs > 0) {
                        await this.backoff.wait();
                        this.initializeWebSocket();
                    }
                }
            };
            this.websocket.onmessage = async (event) => {
                const { resolve } = this.runningMutates[0];
                this.runningMutates.shift();
                const response = reboot_api.react_pb.MutateResponse.fromBinary(new Uint8Array(event.data));
                resolve(response);
                if (this.flushMutates !== undefined &&
                    this.runningMutates.length === 0) {
                    this.flushMutates.set();
                }
            };
        }
    }
    async mutate(partialRequest, update) {
        const request = partialRequest instanceof reboot_api.react_pb.MutateRequest
            ? partialRequest
            : new reboot_api.react_pb.MutateRequest(partialRequest);
        return new Promise((resolve, _) => {
            var _a;
            if (this.loadingReaders === 0) {
                this.runningMutates = this.runningMutates.concat({ request, resolve, update });
                if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                    update({ isLoading: true });
                    try {
                        this.websocket.send(request.toBinary());
                    }
                    catch (_b) {
                        // We'll retry since we've stored in `*Mutates`.
                    }
                }
            }
            else {
                this.queuedMutates = this.queuedMutates.concat({ request, resolve, update });
            }
        });
    }
    async read(method, serializedRequest, bearerToken, responseType, reader) {
        const queryRequest = new reboot_api.react_pb.QueryRequest({
            method,
            request: serializedRequest,
            ...(bearerToken !== undefined && { bearerToken } || {}),
        });
        let expecteds = [];
        // When we disconnect we may not be able to observe
        // responses due to mutations yet there may still be
        // some outstanding responses that are expected which
        // we treat as "orphans" in the sense that we won't
        // observe their idempotency keys but once we reconnect
        // we will still have observed their effects and can
        // call `observed()` on them.
        let orphans = [];
        const id = `${uuidv4()}`;
        this.observers[id] = {
            observe: (idempotencyKey, observed, aborted) => {
                expecteds = expecteds.concat({ idempotencyKey, observed, aborted });
            },
            unobserve: (idempotencyKey) => {
                expecteds = expecteds.filter(expected => expected.idempotencyKey !== idempotencyKey);
                orphans = orphans.filter(orphan => orphan.idempotencyKey !== idempotencyKey);
            }
        };
        try {
            await reboot_api.retryForever(async () => {
                let loaded = false;
                this.loadingReaders += 1;
                // Any mutations started after we've incremented
                // `this.loadingReaders` will be queued until after
                // all the readers have loaded and thus (1) we know all
                // current `expected` are actually `orphans` that
                // we will haved "observed" once we are (re)connected
                // because we flush mutations before starting to read
                // and (2) all queued mutations can stay in `expected`
                // because we will in fact be able to observe them
                // since they won't get sent over the websocket
                // until after we are (re)connected.
                //
                // NOTE: we need to concatenate with `orphans`
                // because we may try to (re)connect multiple times
                // and between each try more mutations may have been
                // made (or queued ones will be moved to running).
                orphans = [...orphans, ...expecteds];
                expecteds = [];
                try {
                    // Wait for potentially completed mutations to flush
                    // before starting to read so that we read the latest
                    // state including those mutations.
                    if (this.hasRunningMutations()) {
                        await this.flushMutations();
                    }
                    reader.setIsLoading(true);
                    const queryResponses = reboot_web.reactiveReader({
                        endpoint: `${this.url}/__/reboot/rpc/${this.stateRef}`,
                        request: queryRequest,
                        signal: reader.abortController.signal,
                    });
                    for await (const queryResponse of queryResponses) {
                        if (!loaded) {
                            if ((this.loadingReaders -= 1) === 0) {
                                this.readersLoadedOrFailed();
                            }
                            loaded = true;
                        }
                        reader.setIsLoading(false);
                        const response = queryResponse.responseOrStatus.case === "response"
                            ? responseType.fromBinary(queryResponse.responseOrStatus.value)
                            : undefined;
                        // If we were disconnected it must be that we've
                        // observed all `orphans` because we waited
                        // for any mutations to flush before we re-started to
                        // read.
                        const haveOrphans = orphans.length;
                        if (haveOrphans > 0) {
                            // We mark all mutations as observed except the
                            // last one which we also invoke all `setResponse`s.
                            // In this way we effectively create a barrier
                            // for all readers that will synchronize on the last
                            // mutation, but note that this still may lead
                            // to some partial state/response updates because
                            // one reader may have actually received a response
                            // while another reader got disconnected. While this
                            // is likely very rare, it is possible. Mitigating
                            // this issue is non-trivial and for now we have
                            // no plans to address it.
                            for (let i = 0; i < orphans.length - 1; i++) {
                                orphans[i].observed(() => { });
                            }
                            await orphans[orphans.length - 1].observed(() => {
                                if (response !== undefined) {
                                    reader.setResponse(response);
                                }
                            });
                            orphans = [];
                        }
                        // We want to check the orphans list AND the expecteds list because
                        // it could be possible that we receive a query response that
                        // contains an idempotency key that we are expecting while having an
                        // orphans list with a length greater than 0. In this case, we don't
                        // want to skip checking the expecteds list just because we have
                        // already checked the orphans list.
                        if (expecteds.length > 0 &&
                            queryResponse.idempotencyKeys.includes(expecteds[0].idempotencyKey)) {
                            await expecteds[0].observed(() => {
                                if (response !== undefined) {
                                    reader.setResponse(response);
                                }
                                expecteds.shift();
                            });
                        }
                        // If we don't have any orphans to observe and we don't have any expecteds to observe,
                        // or at least, the first expecteds _is not observed_ by this response, then go ahead and
                        // pass on the response because it might contain new data that should get shown to the
                        // user (e.g., in a chat room this could be a new message from a different user).
                        else if (response !== undefined && !haveOrphans) {
                            reader.setResponse(response);
                        }
                    }
                    throw new Error('Not expecting stream to ever be done');
                }
                catch (e) {
                    if (!loaded) {
                        if ((this.loadingReaders -= 1) === 0) {
                            this.readersLoadedOrFailed();
                        }
                    }
                    loaded = false;
                    if (reader.abortController.signal.aborted) {
                        for (const { aborted } of [...orphans, ...expecteds]) {
                            aborted();
                        }
                        return;
                    }
                    // Intentionally leave `isLoading: true` here. The outer
                    // `retryForever(...)` will run another attempt and call
                    // `reader.setIsLoading(true)` again at the top of the
                    // try block, but if we cleared it to `false` here first
                    // consumers would observe a brief `false → true → false
                    // → true ...` flip-flop on every retry while we're
                    // actually still trying to (re)connect. Once a response
                    // finally arrives the success path sets it to `false`.
                    if (e instanceof reboot_api.Status) {
                        reader.setStatus(e);
                    }
                    else {
                        console.warn(`[Reboot] Caught unknown exception: ${e instanceof Error ? e.message : JSON.stringify(e)}`);
                    }
                    throw e; // This just retries!
                }
            });
        }
        finally {
            delete this.observers[id];
        }
    }
    async create(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useCreateMutations = this.useCreateMutations.concat(mutation);
        for (const setPending of Object.values(this.useCreateSetPendings)) {
            setPending(this.useCreateMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "Create",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useCreateMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useCreateSetPendings)) {
                        setPending(this.useCreateMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useCreateMutations =
                    this.useCreateMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useCreateSetPendings)) {
                    setPending(this.useCreateMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserCreateResponseFromProtobufShape(Empty.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserCreateAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.Create' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useCreate(id, setPending) {
        this.useCreateSetPendings[id] = setPending;
    }
    unuseCreate(id) {
        delete this.useCreateSetPendings[id];
    }
    async setClaims(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useSetClaimsMutations = this.useSetClaimsMutations.concat(mutation);
        for (const setPending of Object.values(this.useSetClaimsSetPendings)) {
            setPending(this.useSetClaimsMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "SetClaims",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useSetClaimsMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useSetClaimsSetPendings)) {
                        setPending(this.useSetClaimsMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useSetClaimsMutations =
                    this.useSetClaimsMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useSetClaimsSetPendings)) {
                    setPending(this.useSetClaimsMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserSetClaimsResponseFromProtobufShape(Empty.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserSetClaimsAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.SetClaims' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useSetClaims(id, setPending) {
        this.useSetClaimsSetPendings[id] = setPending;
    }
    unuseSetClaims(id) {
        delete this.useSetClaimsSetPendings[id];
    }
    async signUp(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useSignUpMutations = this.useSignUpMutations.concat(mutation);
        for (const setPending of Object.values(this.useSignUpSetPendings)) {
            setPending(this.useSignUpMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "SignUp",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useSignUpMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useSignUpSetPendings)) {
                        setPending(this.useSignUpMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useSignUpMutations =
                    this.useSignUpMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useSignUpSetPendings)) {
                    setPending(this.useSignUpMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserSignUpResponseFromProtobufShape(user_pb.SignUpResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserSignUpAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.SignUp' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useSignUp(id, setPending) {
        this.useSignUpSetPendings[id] = setPending;
    }
    unuseSignUp(id) {
        delete this.useSignUpSetPendings[id];
    }
    async setSurveyData(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useSetSurveyDataMutations = this.useSetSurveyDataMutations.concat(mutation);
        for (const setPending of Object.values(this.useSetSurveyDataSetPendings)) {
            setPending(this.useSetSurveyDataMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "SetSurveyData",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useSetSurveyDataMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useSetSurveyDataSetPendings)) {
                        setPending(this.useSetSurveyDataMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useSetSurveyDataMutations =
                    this.useSetSurveyDataMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useSetSurveyDataSetPendings)) {
                    setPending(this.useSetSurveyDataMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserSetSurveyDataResponseFromProtobufShape(user_pb.SetSurveyDataResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserSetSurveyDataAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.SetSurveyData' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useSetSurveyData(id, setPending) {
        this.useSetSurveyDataSetPendings[id] = setPending;
    }
    unuseSetSurveyData(id) {
        delete this.useSetSurveyDataSetPendings[id];
    }
    async setStatus(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useSetStatusMutations = this.useSetStatusMutations.concat(mutation);
        for (const setPending of Object.values(this.useSetStatusSetPendings)) {
            setPending(this.useSetStatusMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "SetStatus",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useSetStatusMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useSetStatusSetPendings)) {
                        setPending(this.useSetStatusMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useSetStatusMutations =
                    this.useSetStatusMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useSetStatusSetPendings)) {
                    setPending(this.useSetStatusMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserSetStatusResponseFromProtobufShape(user_pb.SetStatusResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserSetStatusAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.SetStatus' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useSetStatus(id, setPending) {
        this.useSetStatusSetPendings[id] = setPending;
    }
    unuseSetStatus(id) {
        delete this.useSetStatusSetPendings[id];
    }
    startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useGetReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'User.Get' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.getFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useGetReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useGet(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useGet(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useGetReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("Get", serializedRequest, bearerToken, user_pb.GetResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(user_pb.GetResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'User.Get' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useGet(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseGet(id, requestBearerTokenHash) {
        const reader = this.useGetReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useGetReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    async addToOrganization(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useAddToOrganizationMutations = this.useAddToOrganizationMutations.concat(mutation);
        for (const setPending of Object.values(this.useAddToOrganizationSetPendings)) {
            setPending(this.useAddToOrganizationMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "AddToOrganization",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useAddToOrganizationMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useAddToOrganizationSetPendings)) {
                        setPending(this.useAddToOrganizationMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useAddToOrganizationMutations =
                    this.useAddToOrganizationMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useAddToOrganizationSetPendings)) {
                    setPending(this.useAddToOrganizationMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserAddToOrganizationResponseFromProtobufShape(user_pb.AddToOrganizationResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserAddToOrganizationAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.AddToOrganization' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useAddToOrganization(id, setPending) {
        this.useAddToOrganizationSetPendings[id] = setPending;
    }
    unuseAddToOrganization(id) {
        delete this.useAddToOrganizationSetPendings[id];
    }
    async removeFromOrganization(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useRemoveFromOrganizationMutations = this.useRemoveFromOrganizationMutations.concat(mutation);
        for (const setPending of Object.values(this.useRemoveFromOrganizationSetPendings)) {
            setPending(this.useRemoveFromOrganizationMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "RemoveFromOrganization",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useRemoveFromOrganizationMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useRemoveFromOrganizationSetPendings)) {
                        setPending(this.useRemoveFromOrganizationMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useRemoveFromOrganizationMutations =
                    this.useRemoveFromOrganizationMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useRemoveFromOrganizationSetPendings)) {
                    setPending(this.useRemoveFromOrganizationMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserRemoveFromOrganizationResponseFromProtobufShape(user_pb.RemoveFromOrganizationResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserRemoveFromOrganizationAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.RemoveFromOrganization' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useRemoveFromOrganization(id, setPending) {
        this.useRemoveFromOrganizationSetPendings[id] = setPending;
    }
    unuseRemoveFromOrganization(id) {
        delete this.useRemoveFromOrganizationSetPendings[id];
    }
    async setLastSelectedOrganization(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useSetLastSelectedOrganizationMutations = this.useSetLastSelectedOrganizationMutations.concat(mutation);
        for (const setPending of Object.values(this.useSetLastSelectedOrganizationSetPendings)) {
            setPending(this.useSetLastSelectedOrganizationMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "SetLastSelectedOrganization",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useSetLastSelectedOrganizationMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useSetLastSelectedOrganizationSetPendings)) {
                        setPending(this.useSetLastSelectedOrganizationMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useSetLastSelectedOrganizationMutations =
                    this.useSetLastSelectedOrganizationMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useSetLastSelectedOrganizationSetPendings)) {
                    setPending(this.useSetLastSelectedOrganizationMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserSetLastSelectedOrganizationResponseFromProtobufShape(user_pb.SetLastSelectedOrganizationResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserSetLastSelectedOrganizationAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.SetLastSelectedOrganization' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useSetLastSelectedOrganization(id, setPending) {
        this.useSetLastSelectedOrganizationSetPendings[id] = setPending;
    }
    unuseSetLastSelectedOrganization(id) {
        delete this.useSetLastSelectedOrganizationSetPendings[id];
    }
    async createAPIKey(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useCreateAPIKeyMutations = this.useCreateAPIKeyMutations.concat(mutation);
        for (const setPending of Object.values(this.useCreateAPIKeySetPendings)) {
            setPending(this.useCreateAPIKeyMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "CreateAPIKey",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useCreateAPIKeyMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useCreateAPIKeySetPendings)) {
                        setPending(this.useCreateAPIKeyMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useCreateAPIKeyMutations =
                    this.useCreateAPIKeyMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useCreateAPIKeySetPendings)) {
                    setPending(this.useCreateAPIKeyMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserCreateAPIKeyResponseFromProtobufShape(user_pb.CreateAPIKeyResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserCreateAPIKeyAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.CreateAPIKey' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useCreateAPIKey(id, setPending) {
        this.useCreateAPIKeySetPendings[id] = setPending;
    }
    unuseCreateAPIKey(id) {
        delete this.useCreateAPIKeySetPendings[id];
    }
    async deleteAPIKey(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useDeleteAPIKeyMutations = this.useDeleteAPIKeyMutations.concat(mutation);
        for (const setPending of Object.values(this.useDeleteAPIKeySetPendings)) {
            setPending(this.useDeleteAPIKeyMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "DeleteAPIKey",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useDeleteAPIKeyMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useDeleteAPIKeySetPendings)) {
                        setPending(this.useDeleteAPIKeyMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useDeleteAPIKeyMutations =
                    this.useDeleteAPIKeyMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useDeleteAPIKeySetPendings)) {
                    setPending(this.useDeleteAPIKeyMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UserDeleteAPIKeyResponseFromProtobufShape(user_pb.DeleteAPIKeyResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UserDeleteAPIKeyAborted.fromStatus(status);
                    console.warn(`[Reboot] 'User.DeleteAPIKey' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useDeleteAPIKey(id, setPending) {
        this.useDeleteAPIKeySetPendings[id] = setPending;
    }
    unuseDeleteAPIKey(id) {
        delete this.useDeleteAPIKeySetPendings[id];
    }
    startGetAPIKeysForOrganization(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useGetAPIKeysForOrganizationReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'User.GetAPIKeysForOrganization' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.getAPIKeysForOrganizationFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useGetAPIKeysForOrganizationReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useGetAPIKeysForOrganization(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useGetAPIKeysForOrganization(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useGetAPIKeysForOrganizationReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("GetAPIKeysForOrganization", serializedRequest, bearerToken, user_pb.GetAPIKeysForOrganizationResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(user_pb.GetAPIKeysForOrganizationResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'User.GetAPIKeysForOrganization' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useGetAPIKeysForOrganization(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startGetAPIKeysForOrganization(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseGetAPIKeysForOrganization(id, requestBearerTokenHash) {
        const reader = this.useGetAPIKeysForOrganizationReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useGetAPIKeysForOrganizationReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    static use(id, stateRef, url) {
        if (!(id in this.instances)) {
            this.instances[id] = new UserInstance(id, stateRef, url);
        }
        else {
            this.instances[id].ref();
        }
        return this.instances[id];
    }
    unuse() {
        if (this.unref() === 0) {
            delete UserInstance.instances[this.id];
        }
    }
}
UserInstance.instances = {};
export function useUser({ id: providedId } = {}) {
    var _a;
    // Resolve `id` from the frontend-agnostic state-ID map. A `null` map
    // means that resolution is still in flight; an empty map means it
    // resolved with no default ID for us.
    const defaultIds = useDefaultStateIds();
    const isLoading = defaultIds === null;
    // Resolve ID: explicit > URL param (dev) > default-ID map.
    const devId = useMemo(() => {
        // React Native defines `window` but not `window.location`, so both
        // must be checked.
        if (typeof window !== "undefined" &&
            typeof window.location !== "undefined") {
            return new URLSearchParams(window.location.search).get("rbt.cloud.v1alpha1.user.User.id");
        }
        return null;
    }, []);
    const toolInputId = typeof (defaultIds === null || defaultIds === void 0 ? void 0 : defaultIds["rbt.cloud.v1alpha1.user.User"]) === "string"
        ? defaultIds["rbt.cloud.v1alpha1.user.User"]
        : null;
    const resolvedId = (_a = providedId !== null && providedId !== void 0 ? providedId : devId) !== null && _a !== void 0 ? _a : toolInputId;
    // Without a resolved ID we still run every hook below (rules of
    // hooks), binding to the inert empty-ID instance that opens no
    // socket.
    const id = resolvedId !== null && resolvedId !== void 0 ? resolvedId : "";
    // The unresolved no-id case carries an empty `stateRef` rather than
    // computing one. Keyed on the id being unresolved — an explicitly
    // passed empty id still reaches `stateIdToRef`, which rejects it.
    const stateRef = resolvedId == null
        ? ""
        : reboot_api.stateIdToRef("rbt.cloud.v1alpha1.user.User", id);
    const rebootClient = reboot_react.useRebootClient();
    const url = rebootClient.url;
    const bearerToken = rebootClient.bearerToken;
    const refreshBearerToken = useRefreshBearerToken();
    const [instance, setInstance] = useState(() => {
        return UserInstance.use(id, stateRef, url);
    });
    if (instance.id !== id) {
        setInstance(UserInstance.use(id, stateRef, url));
    }
    useEffect(() => {
        return () => {
            instance.unuse();
        };
    }, [instance]);
    const headers = useMemo(() => {
        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        headers.append("Connection", "keep-alive");
        if (bearerToken !== undefined) {
            headers.append("Authorization", `Bearer ${bearerToken}`);
        }
        return headers;
    }, [bearerToken]);
    function useCreate() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useCreate(id, setPending);
            return () => {
                instance.unuseCreate(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const create = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserCreateRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.create(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.create({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        create.pending = pending;
        return create;
    }
    const create = useCreate();
    function useSetClaims() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useSetClaims(id, setPending);
            return () => {
                instance.unuseSetClaims(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const setClaims = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserSetClaimsRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.setClaims(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.setClaims({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        setClaims.pending = pending;
        return setClaims;
    }
    const setClaims = useSetClaims();
    function useSignUp() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useSignUp(id, setPending);
            return () => {
                instance.unuseSignUp(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const signUp = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserSignUpRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.signUp(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.signUp({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        signUp.pending = pending;
        return signUp;
    }
    const signUp = useSignUp();
    function useSetSurveyData() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useSetSurveyData(id, setPending);
            return () => {
                instance.unuseSetSurveyData(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const setSurveyData = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserSetSurveyDataRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.setSurveyData(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.setSurveyData({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        setSurveyData.pending = pending;
        return setSurveyData;
    }
    const setSurveyData = useSetSurveyData();
    function useSetStatus() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useSetStatus(id, setPending);
            return () => {
                instance.unuseSetStatus(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const setStatus = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserSetStatusRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.setStatus(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.setStatus({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        setStatus.pending = pending;
        return setStatus;
    }
    const setStatus = useSetStatus();
    function useGet(partialRequest = {}, options = { suspense: false }) {
        const newRequest = UserGetRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:Get:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && UserGetResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && UserGetAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useGet(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(UserGetResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = UserGetAborted.fromStatus(status);
                console.warn(`[Reboot] 'User.Get' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseGet(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function get(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = UserGetRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UserMethods/Get`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw UserGetAborted.fromStatus(status);
                        }
                        throw new UserGetAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof UserGetAborted) {
                            return { aborted: e };
                        }
                        const aborted = new UserGetAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.user.UserMethods.Get\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UserMethods/Get`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: UserGetResponseFromProtobufShape((user_pb.GetResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new UserGetAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new UserGetAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new UserGetAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UserMethods/Get`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: UserGetResponseFromProtobufShape((user_pb.GetResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = UserGetAborted.fromStatus(status);
                console.warn(`[Reboot] 'User.Get' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new UserGetAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: UserGetResponseFromProtobufShape((user_pb.GetResponse.fromJson(await response.json())))
            };
        }
    }
    function useAddToOrganization() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useAddToOrganization(id, setPending);
            return () => {
                instance.unuseAddToOrganization(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const addToOrganization = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserAddToOrganizationRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.addToOrganization(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.addToOrganization({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        addToOrganization.pending = pending;
        return addToOrganization;
    }
    const addToOrganization = useAddToOrganization();
    function useRemoveFromOrganization() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useRemoveFromOrganization(id, setPending);
            return () => {
                instance.unuseRemoveFromOrganization(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const removeFromOrganization = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserRemoveFromOrganizationRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.removeFromOrganization(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.removeFromOrganization({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        removeFromOrganization.pending = pending;
        return removeFromOrganization;
    }
    const removeFromOrganization = useRemoveFromOrganization();
    function useSetLastSelectedOrganization() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useSetLastSelectedOrganization(id, setPending);
            return () => {
                instance.unuseSetLastSelectedOrganization(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const setLastSelectedOrganization = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserSetLastSelectedOrganizationRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.setLastSelectedOrganization(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.setLastSelectedOrganization({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        setLastSelectedOrganization.pending = pending;
        return setLastSelectedOrganization;
    }
    const setLastSelectedOrganization = useSetLastSelectedOrganization();
    function useCreateAPIKey() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useCreateAPIKey(id, setPending);
            return () => {
                instance.unuseCreateAPIKey(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const createAPIKey = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserCreateAPIKeyRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.createAPIKey(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.createAPIKey({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        createAPIKey.pending = pending;
        return createAPIKey;
    }
    const createAPIKey = useCreateAPIKey();
    function useDeleteAPIKey() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useDeleteAPIKey(id, setPending);
            return () => {
                instance.unuseDeleteAPIKey(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const deleteAPIKey = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UserDeleteAPIKeyRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.deleteAPIKey(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.deleteAPIKey({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        deleteAPIKey.pending = pending;
        return deleteAPIKey;
    }
    const deleteAPIKey = useDeleteAPIKey();
    function useGetAPIKeysForOrganization(partialRequest = {}, options = { suspense: false }) {
        const newRequest = UserGetAPIKeysForOrganizationRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:GetAPIKeysForOrganization:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startGetAPIKeysForOrganization(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && UserGetAPIKeysForOrganizationResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && UserGetAPIKeysForOrganizationAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useGetAPIKeysForOrganization(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(UserGetAPIKeysForOrganizationResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = UserGetAPIKeysForOrganizationAborted.fromStatus(status);
                console.warn(`[Reboot] 'User.GetAPIKeysForOrganization' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseGetAPIKeysForOrganization(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function getAPIKeysForOrganization(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = UserGetAPIKeysForOrganizationRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UserMethods/GetAPIKeysForOrganization`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw UserGetAPIKeysForOrganizationAborted.fromStatus(status);
                        }
                        throw new UserGetAPIKeysForOrganizationAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof UserGetAPIKeysForOrganizationAborted) {
                            return { aborted: e };
                        }
                        const aborted = new UserGetAPIKeysForOrganizationAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.user.UserMethods.GetAPIKeysForOrganization\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UserMethods/GetAPIKeysForOrganization`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: UserGetAPIKeysForOrganizationResponseFromProtobufShape((user_pb.GetAPIKeysForOrganizationResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new UserGetAPIKeysForOrganizationAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new UserGetAPIKeysForOrganizationAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new UserGetAPIKeysForOrganizationAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UserMethods/GetAPIKeysForOrganization`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: UserGetAPIKeysForOrganizationResponseFromProtobufShape((user_pb.GetAPIKeysForOrganizationResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = UserGetAPIKeysForOrganizationAborted.fromStatus(status);
                console.warn(`[Reboot] 'User.GetAPIKeysForOrganization' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new UserGetAPIKeysForOrganizationAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: UserGetAPIKeysForOrganizationResponseFromProtobufShape((user_pb.GetAPIKeysForOrganizationResponse.fromJson(await response.json())))
            };
        }
    }
    // Don't re-render if `id` hasn't changed.
    const api = useMemo(() => ({
        state_id: id,
        mutators: {
            create,
            setClaims,
            signUp,
            setSurveyData,
            setStatus,
            addToOrganization,
            removeFromOrganization,
            setLastSelectedOrganization,
            createAPIKey,
            deleteAPIKey,
        },
        idempotently: ({ key }) => {
            return {
                create: (partialRequest, options) => create(partialRequest, { ...options, key }),
                setClaims: (partialRequest, options) => setClaims(partialRequest, { ...options, key }),
                signUp: (partialRequest, options) => signUp(partialRequest, { ...options, key }),
                setSurveyData: (partialRequest, options) => setSurveyData(partialRequest, { ...options, key }),
                setStatus: (partialRequest, options) => setStatus(partialRequest, { ...options, key }),
                addToOrganization: (partialRequest, options) => addToOrganization(partialRequest, { ...options, key }),
                removeFromOrganization: (partialRequest, options) => removeFromOrganization(partialRequest, { ...options, key }),
                setLastSelectedOrganization: (partialRequest, options) => setLastSelectedOrganization(partialRequest, { ...options, key }),
                createAPIKey: (partialRequest, options) => createAPIKey(partialRequest, { ...options, key }),
                deleteAPIKey: (partialRequest, options) => deleteAPIKey(partialRequest, { ...options, key }),
            };
        },
        create,
        setClaims,
        signUp,
        setSurveyData,
        setStatus,
        get,
        useGet,
        addToOrganization,
        removeFromOrganization,
        setLastSelectedOrganization,
        createAPIKey,
        deleteAPIKey,
        getAPIKeysForOrganization,
        useGetAPIKeysForOrganization,
    }), [id, instance, bearerToken, refreshBearerToken]);
    // An explicit `id` caller gets the handle directly; a no-id caller
    // gets the `{ user, isLoading }`
    // shape, where the handle is `undefined` until a default ID
    // resolves.
    if (providedId !== undefined) {
        return api;
    }
    return {
        user: resolvedId ? api : undefined,
        isLoading,
    };
}
;
export class User {
}
User.State = UserProto;
class UsersInstance {
    constructor(id, stateRef, url) {
        this.observers = {};
        this.loadingReaders = 0;
        this.runningMutates = [];
        this.queuedMutates = [];
        this.flushMutates = undefined;
        this.websocket = undefined;
        this.backoff = new reboot_api.Backoff();
        this.useAddMutations = [];
        this.useAddSetPendings = {};
        this.useGetReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.getFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.id = id;
        this.stateRef = stateRef;
        this.url = url;
        this.refs = 1;
        // An empty `id` marks the inert instance shared by every no-id
        // caller while no default ID has resolved (e.g. signed out): it
        // opens no socket so there's nothing to connect to.
        if (id !== "") {
            reboot_web.websockets.connect(this.url, this.stateRef);
            this.initializeWebSocket();
        }
    }
    ref() {
        this.refs += 1;
        return this.refs;
    }
    unref() {
        this.refs -= 1;
        if (this.refs === 0 && this.websocket !== undefined) {
            this.websocket.close();
            reboot_web.websockets.disconnect(this.url, this.stateRef);
        }
        return this.refs;
    }
    hasRunningMutations() {
        return this.runningMutates.length > 0;
    }
    async flushMutations() {
        if (this.flushMutates === undefined) {
            this.flushMutates = new reboot_api.Event();
        }
        await this.flushMutates.wait();
    }
    readersLoadedOrFailed() {
        var _a;
        this.flushMutates = undefined;
        if (this.queuedMutates.length > 0) {
            this.runningMutates = this.queuedMutates;
            this.queuedMutates = [];
            if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                for (const { request, update } of this.runningMutates) {
                    update({ isLoading: true });
                    try {
                        this.websocket.send(request.toBinary());
                    }
                    catch (_b) {
                        // We'll retry since we've stored in `*Mutates`.
                    }
                }
            }
        }
    }
    initializeWebSocket() {
        if (this.websocket === undefined && this.refs > 0 && this.id !== "") {
            const url = new URL(`${this.url}/__/reboot/rpc/${this.stateRef}`);
            url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
            this.websocket = reboot_web.websockets.create(url);
            this.websocket.binaryType = "arraybuffer";
            this.websocket.onopen = () => {
                var _a;
                if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                    for (const { request, update } of this.runningMutates) {
                        update({ isLoading: true });
                        try {
                            this.websocket.send(request.toBinary());
                        }
                        catch (_b) {
                            // We'll retry since we've stored in `*Mutates`.
                        }
                    }
                }
            };
            this.websocket.onerror = async () => {
                if (this.websocket !== undefined) {
                    this.websocket = undefined;
                    for (const { update } of this.runningMutates) {
                        update({ isLoading: false, error: "WebSocket disconnected" });
                    }
                    if (this.refs > 0) {
                        if (this.runningMutates.length > 0) {
                            console.warn(`[Reboot] WebSocket disconnected, ${this.runningMutates.length} outstanding mutations will be retried when we reconnect`);
                        }
                        await this.backoff.wait();
                        this.initializeWebSocket();
                    }
                }
            };
            this.websocket.onclose = async () => {
                if (this.websocket !== undefined) {
                    this.websocket = undefined;
                    for (const { update } of this.runningMutates) {
                        update({ isLoading: false, error: "WebSocket disconnected" });
                    }
                    if (this.refs > 0) {
                        await this.backoff.wait();
                        this.initializeWebSocket();
                    }
                }
            };
            this.websocket.onmessage = async (event) => {
                const { resolve } = this.runningMutates[0];
                this.runningMutates.shift();
                const response = reboot_api.react_pb.MutateResponse.fromBinary(new Uint8Array(event.data));
                resolve(response);
                if (this.flushMutates !== undefined &&
                    this.runningMutates.length === 0) {
                    this.flushMutates.set();
                }
            };
        }
    }
    async mutate(partialRequest, update) {
        const request = partialRequest instanceof reboot_api.react_pb.MutateRequest
            ? partialRequest
            : new reboot_api.react_pb.MutateRequest(partialRequest);
        return new Promise((resolve, _) => {
            var _a;
            if (this.loadingReaders === 0) {
                this.runningMutates = this.runningMutates.concat({ request, resolve, update });
                if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                    update({ isLoading: true });
                    try {
                        this.websocket.send(request.toBinary());
                    }
                    catch (_b) {
                        // We'll retry since we've stored in `*Mutates`.
                    }
                }
            }
            else {
                this.queuedMutates = this.queuedMutates.concat({ request, resolve, update });
            }
        });
    }
    async read(method, serializedRequest, bearerToken, responseType, reader) {
        const queryRequest = new reboot_api.react_pb.QueryRequest({
            method,
            request: serializedRequest,
            ...(bearerToken !== undefined && { bearerToken } || {}),
        });
        let expecteds = [];
        // When we disconnect we may not be able to observe
        // responses due to mutations yet there may still be
        // some outstanding responses that are expected which
        // we treat as "orphans" in the sense that we won't
        // observe their idempotency keys but once we reconnect
        // we will still have observed their effects and can
        // call `observed()` on them.
        let orphans = [];
        const id = `${uuidv4()}`;
        this.observers[id] = {
            observe: (idempotencyKey, observed, aborted) => {
                expecteds = expecteds.concat({ idempotencyKey, observed, aborted });
            },
            unobserve: (idempotencyKey) => {
                expecteds = expecteds.filter(expected => expected.idempotencyKey !== idempotencyKey);
                orphans = orphans.filter(orphan => orphan.idempotencyKey !== idempotencyKey);
            }
        };
        try {
            await reboot_api.retryForever(async () => {
                let loaded = false;
                this.loadingReaders += 1;
                // Any mutations started after we've incremented
                // `this.loadingReaders` will be queued until after
                // all the readers have loaded and thus (1) we know all
                // current `expected` are actually `orphans` that
                // we will haved "observed" once we are (re)connected
                // because we flush mutations before starting to read
                // and (2) all queued mutations can stay in `expected`
                // because we will in fact be able to observe them
                // since they won't get sent over the websocket
                // until after we are (re)connected.
                //
                // NOTE: we need to concatenate with `orphans`
                // because we may try to (re)connect multiple times
                // and between each try more mutations may have been
                // made (or queued ones will be moved to running).
                orphans = [...orphans, ...expecteds];
                expecteds = [];
                try {
                    // Wait for potentially completed mutations to flush
                    // before starting to read so that we read the latest
                    // state including those mutations.
                    if (this.hasRunningMutations()) {
                        await this.flushMutations();
                    }
                    reader.setIsLoading(true);
                    const queryResponses = reboot_web.reactiveReader({
                        endpoint: `${this.url}/__/reboot/rpc/${this.stateRef}`,
                        request: queryRequest,
                        signal: reader.abortController.signal,
                    });
                    for await (const queryResponse of queryResponses) {
                        if (!loaded) {
                            if ((this.loadingReaders -= 1) === 0) {
                                this.readersLoadedOrFailed();
                            }
                            loaded = true;
                        }
                        reader.setIsLoading(false);
                        const response = queryResponse.responseOrStatus.case === "response"
                            ? responseType.fromBinary(queryResponse.responseOrStatus.value)
                            : undefined;
                        // If we were disconnected it must be that we've
                        // observed all `orphans` because we waited
                        // for any mutations to flush before we re-started to
                        // read.
                        const haveOrphans = orphans.length;
                        if (haveOrphans > 0) {
                            // We mark all mutations as observed except the
                            // last one which we also invoke all `setResponse`s.
                            // In this way we effectively create a barrier
                            // for all readers that will synchronize on the last
                            // mutation, but note that this still may lead
                            // to some partial state/response updates because
                            // one reader may have actually received a response
                            // while another reader got disconnected. While this
                            // is likely very rare, it is possible. Mitigating
                            // this issue is non-trivial and for now we have
                            // no plans to address it.
                            for (let i = 0; i < orphans.length - 1; i++) {
                                orphans[i].observed(() => { });
                            }
                            await orphans[orphans.length - 1].observed(() => {
                                if (response !== undefined) {
                                    reader.setResponse(response);
                                }
                            });
                            orphans = [];
                        }
                        // We want to check the orphans list AND the expecteds list because
                        // it could be possible that we receive a query response that
                        // contains an idempotency key that we are expecting while having an
                        // orphans list with a length greater than 0. In this case, we don't
                        // want to skip checking the expecteds list just because we have
                        // already checked the orphans list.
                        if (expecteds.length > 0 &&
                            queryResponse.idempotencyKeys.includes(expecteds[0].idempotencyKey)) {
                            await expecteds[0].observed(() => {
                                if (response !== undefined) {
                                    reader.setResponse(response);
                                }
                                expecteds.shift();
                            });
                        }
                        // If we don't have any orphans to observe and we don't have any expecteds to observe,
                        // or at least, the first expecteds _is not observed_ by this response, then go ahead and
                        // pass on the response because it might contain new data that should get shown to the
                        // user (e.g., in a chat room this could be a new message from a different user).
                        else if (response !== undefined && !haveOrphans) {
                            reader.setResponse(response);
                        }
                    }
                    throw new Error('Not expecting stream to ever be done');
                }
                catch (e) {
                    if (!loaded) {
                        if ((this.loadingReaders -= 1) === 0) {
                            this.readersLoadedOrFailed();
                        }
                    }
                    loaded = false;
                    if (reader.abortController.signal.aborted) {
                        for (const { aborted } of [...orphans, ...expecteds]) {
                            aborted();
                        }
                        return;
                    }
                    // Intentionally leave `isLoading: true` here. The outer
                    // `retryForever(...)` will run another attempt and call
                    // `reader.setIsLoading(true)` again at the top of the
                    // try block, but if we cleared it to `false` here first
                    // consumers would observe a brief `false → true → false
                    // → true ...` flip-flop on every retry while we're
                    // actually still trying to (re)connect. Once a response
                    // finally arrives the success path sets it to `false`.
                    if (e instanceof reboot_api.Status) {
                        reader.setStatus(e);
                    }
                    else {
                        console.warn(`[Reboot] Caught unknown exception: ${e instanceof Error ? e.message : JSON.stringify(e)}`);
                    }
                    throw e; // This just retries!
                }
            });
        }
        finally {
            delete this.observers[id];
        }
    }
    async add(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useAddMutations = this.useAddMutations.concat(mutation);
        for (const setPending of Object.values(this.useAddSetPendings)) {
            setPending(this.useAddMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "Add",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useAddMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useAddSetPendings)) {
                        setPending(this.useAddMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useAddMutations =
                    this.useAddMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useAddSetPendings)) {
                    setPending(this.useAddMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: UsersAddResponseFromProtobufShape(user_pb.AddResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = UsersAddAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Users.Add' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useAdd(id, setPending) {
        this.useAddSetPendings[id] = setPending;
    }
    unuseAdd(id) {
        delete this.useAddSetPendings[id];
    }
    startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useGetReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Users.Get' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.getFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useGetReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useGet(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useGet(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useGetReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("Get", serializedRequest, bearerToken, user_pb.UsersGetResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(user_pb.UsersGetResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Users.Get' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useGet(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseGet(id, requestBearerTokenHash) {
        const reader = this.useGetReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useGetReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    static use(id, stateRef, url) {
        if (!(id in this.instances)) {
            this.instances[id] = new UsersInstance(id, stateRef, url);
        }
        else {
            this.instances[id].ref();
        }
        return this.instances[id];
    }
    unuse() {
        if (this.unref() === 0) {
            delete UsersInstance.instances[this.id];
        }
    }
}
UsersInstance.instances = {};
export function useUsers({ id: providedId } = {}) {
    var _a;
    // Resolve `id` from the frontend-agnostic state-ID map. A `null` map
    // means that resolution is still in flight; an empty map means it
    // resolved with no default ID for us.
    const defaultIds = useDefaultStateIds();
    const isLoading = defaultIds === null;
    // Resolve ID: explicit > URL param (dev) > default-ID map.
    const devId = useMemo(() => {
        // React Native defines `window` but not `window.location`, so both
        // must be checked.
        if (typeof window !== "undefined" &&
            typeof window.location !== "undefined") {
            return new URLSearchParams(window.location.search).get("rbt.cloud.v1alpha1.user.Users.id");
        }
        return null;
    }, []);
    const toolInputId = typeof (defaultIds === null || defaultIds === void 0 ? void 0 : defaultIds["rbt.cloud.v1alpha1.user.Users"]) === "string"
        ? defaultIds["rbt.cloud.v1alpha1.user.Users"]
        : null;
    const resolvedId = (_a = providedId !== null && providedId !== void 0 ? providedId : devId) !== null && _a !== void 0 ? _a : toolInputId;
    // Without a resolved ID we still run every hook below (rules of
    // hooks), binding to the inert empty-ID instance that opens no
    // socket.
    const id = resolvedId !== null && resolvedId !== void 0 ? resolvedId : "";
    // The unresolved no-id case carries an empty `stateRef` rather than
    // computing one. Keyed on the id being unresolved — an explicitly
    // passed empty id still reaches `stateIdToRef`, which rejects it.
    const stateRef = resolvedId == null
        ? ""
        : reboot_api.stateIdToRef("rbt.cloud.v1alpha1.user.Users", id);
    const rebootClient = reboot_react.useRebootClient();
    const url = rebootClient.url;
    const bearerToken = rebootClient.bearerToken;
    const refreshBearerToken = useRefreshBearerToken();
    const [instance, setInstance] = useState(() => {
        return UsersInstance.use(id, stateRef, url);
    });
    if (instance.id !== id) {
        setInstance(UsersInstance.use(id, stateRef, url));
    }
    useEffect(() => {
        return () => {
            instance.unuse();
        };
    }, [instance]);
    const headers = useMemo(() => {
        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        headers.append("Connection", "keep-alive");
        if (bearerToken !== undefined) {
            headers.append("Authorization", `Bearer ${bearerToken}`);
        }
        return headers;
    }, [bearerToken]);
    function useAdd() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useAdd(id, setPending);
            return () => {
                instance.unuseAdd(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const add = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = UsersAddRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.add(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.add({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        add.pending = pending;
        return add;
    }
    const add = useAdd();
    function useGet(partialRequest = {}, options = { suspense: false }) {
        const newRequest = UsersGetRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:Get:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && UsersGetResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && UsersGetAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useGet(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(UsersGetResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = UsersGetAborted.fromStatus(status);
                console.warn(`[Reboot] 'Users.Get' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseGet(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function get(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = UsersGetRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UsersMethods/Get`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw UsersGetAborted.fromStatus(status);
                        }
                        throw new UsersGetAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof UsersGetAborted) {
                            return { aborted: e };
                        }
                        const aborted = new UsersGetAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.user.UsersMethods.Get\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UsersMethods/Get`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: UsersGetResponseFromProtobufShape((user_pb.UsersGetResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new UsersGetAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new UsersGetAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new UsersGetAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.user.UsersMethods/Get`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: UsersGetResponseFromProtobufShape((user_pb.UsersGetResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = UsersGetAborted.fromStatus(status);
                console.warn(`[Reboot] 'Users.Get' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new UsersGetAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: UsersGetResponseFromProtobufShape((user_pb.UsersGetResponse.fromJson(await response.json())))
            };
        }
    }
    // Don't re-render if `id` hasn't changed.
    const api = useMemo(() => ({
        state_id: id,
        mutators: {
            add,
        },
        idempotently: ({ key }) => {
            return {
                add: (partialRequest, options) => add(partialRequest, { ...options, key }),
            };
        },
        add,
        get,
        useGet,
    }), [id, instance, bearerToken, refreshBearerToken]);
    // An explicit `id` caller gets the handle directly; a no-id caller
    // gets the `{ users, isLoading }`
    // shape, where the handle is `undefined` until a default ID
    // resolves.
    if (providedId !== undefined) {
        return api;
    }
    return {
        users: resolvedId ? api : undefined,
        isLoading,
    };
}
;
export class Users {
}
Users.State = UsersProto;
